import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=b44b7e64&scoped=true&lang=pug"
import script from "./Totals.vue?vue&type=script&lang=js"
export * from "./Totals.vue?vue&type=script&lang=js"
import style0 from "./Totals.vue?vue&type=style&index=0&id=b44b7e64&prod&lang=scss&scoped=true"
import style1 from "./Totals.vue?vue&type=style&index=1&id=b44b7e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44b7e64",
  null
  
)

export default component.exports